<template>
    <website-page>
        <digital-signage-navigation></digital-signage-navigation>

        <div class="main-section overlay">
            <b-container>
                <h1 class="blured" v-tr>
                    Video Walls and Corporate Digital Signage|
                    Murs vidéo et communication d'entreprise numérique
                </h1>
                <h2 class="subtitle blured" v-tr>
                    Cutting Edge Digital Signage Solutions for Businesses|
                    Solutions d'affichage numérique de pointe pour les entreprises
                </h2>
                <p class="presentation" v-tr>
                    Go big with our powerful and flexible solution for Digital Video Walls and Corporate Signage. We provide a Turnkey solution including creating tailor made visual content to amaze your visitors.|
                    Voyez grand avec notre solution puissante et flexible de murs vidéo numériques et de communication d'entreprise. Nous offrons une solution clé en main incluant la création de contenu multimédia sur mesure pour impressionner vos visiteurs.
                </p>
                <b-row class="mt-5">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/oreal_canada.png')" alt="Client  Digital Signage Oreal Canada"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/shriners.png')" alt="Client  Digital Signage Hospital Shriners"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/alexis-nihon.png')" alt="Client  Digital Signage Alexis Nihon Shopping Center"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/mc_donald.png')" alt="Client  Digital Signage McDonald"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/mc_cafe.png')" alt="Client Digital Signage McCafé"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/cegep_beauce_appalache.png')" alt="Client Digital Cegep Beauce Appalache"></b-img>
                    </b-col>
                </b-row>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#digital-videowall'" variant="outline-light"><span v-tr>Discover more|En savoir plus</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="digital-videowall" class="page inverted">
                <h3 class="text-center mb-5" v-tr>
                    Video Walls and Corporate Office|Murs vidéos et affichage de bureau
                </h3>

                <b-carousel controls indicators class="dark" :interval="4000">
                    <b-carousel-slide :img-src="require('../../assets/img/examples/videowall.jpg')"
                                      alt="Oreal Canada Digital Video Wall with Eye-In Media">
                    </b-carousel-slide>
                    <b-carousel-slide :img-src="require('../../assets/img/examples/videowall_alt.jpg')"
                                      alt="Oreal Canada Corporate Office Digital Signage with Eye-In Media">
                    </b-carousel-slide>
                </b-carousel>
            <b-container>

                <h5 class="text-center mt-5" v-tr>
                    Eye-In Media pioneered the introduction of video walls to quick restaurant services. Eye-In Media also specializes in installing video walls in shopping malls and corporate offices.|
                    Eye-In est un pionnier des "vidéomosaïques" dans l’industrie de la restauration rapide. Eye-in se spécialise aussi dans l’installation des vidéosmosaïques dans les grandes surfaces publiques et dans les grands bureaux corporatifs.
                </h5>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#videowall-creation'" variant="outline-light"><span v-tr>Creation Process|Processus de création</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="videowall-creation" class="page">
            <b-container>
                <h3 class="text-center mb-4" v-tr>
                    Video Wall Creation Process|Processus de création d'un mur vidéo
                </h3>
                <youtube-player iframe-src="https://www.youtube.com/embed/1-RsQp0Lkos" :poster="require('../../assets/img/video-splash/storyboard-pro-creation.jpg')">
                </youtube-player>

                <h5 class="text-center mt-4" v-tr>
                    Want to know more about how we create beautiful content for a Video Wall? Here is our process from the early concepts to the final product.|
                    Vous voulez en savoir plus sur la façon dont nous créons de beaux contenus pour un mur vidéo? Voici notre processus du premier concept au produit final.
                </h5>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#clients'" variant="light"><span v-tr>Our Clients|Nos clients</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="clients" class="page inverted">
            <b-container>
                <h3 class="text-center" v-tr>They chose us|Ils nous ont choisis</h3>
                <signage-corporate-office-client-cards></signage-corporate-office-client-cards>

                <div class="text-center mt-4">
                    <router-link :to="'/digital-signage/clients|/affichage-numerique/clients'|tr"><span v-tr>All our clients and markets|Tous nos clients et marchés</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    <br>
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#contact-us'" variant="light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import SignageCorporateOfficeClientCards from "@/client-cards/signage-corporate-office-client-cards.vue";

    import DigitalSignageNavigation from "@/navigation/digital-signage-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";

    export default {
        name: `digital-signage-videowalls`,
        components: { SignageCorporateOfficeClientCards, DigitalSignageNavigation },
        metaInfo: {
            title: translate(`Video Walls and Corporate Digital Signage|Murs vidéo et communication d'entreprise numérique`),
            meta: [
                { name: `keywords`, content: `videowall, video wall, screens, tvs, amazing, professional, retail, corporate, office, businesses` },
                { name: `description`, content: translate(`Mesmerize your visitors and inform your employees with the Best Digital Signage Technology|Hypnotisez vos visiteurs et informez vos employés avec la meilleure technologie d'affichage numérique`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/style/bootstrap-theme";

    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/videowall.jpg');
        background-image: url('../../assets/img/backgrounds/videowall.webp');
        background-size: cover;
        background-position: center bottom;
    }
</style>
